//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'user-help-person',
  data: function data() {
    return {
      activeName: '1',
      isShowMode: true,
      //系统进入显示查看功能
      getLoadingShow: false,
      boyOrGirl: 'boy',
      navActive: 1,
      menuArr: []
    };
  },
  beforeCreate: function beforeCreate() {// 组件实例刚被创建，组件属性计算之前，如data属性等
  },
  created: function created() {// 组件实例创建完成，属性已绑定，但Dom还未生成，$el属性还不存在
  },
  beforeMount: function beforeMount() {
    this.getLoadingShow = true; // 模板编译/挂载之前
  },
  methods: {
    isShowModeHandler: function isShowModeHandler(data) {
      this.isShowMode = data;
    },
    // 档案信息 --左侧导航及内容区切换
    changeMenu: function changeMenu(index) {
      this.navActive = index;

      if (index === 2) {
        // window.open("https://yitaibms-web-new.oss-cn-shanghai.aliyuncs.com/%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88%E7%9C%81%E5%B8%82%E5%8E%BF%E7%AE%A1%E7%90%86%E5%91%98%EF%BC%89.pdf");
        if (process && process.env && process.env.VUE_APP_ENV_FlAG && process.env.VUE_APP_ENV_FlAG === 'wlmq') {
          window.open('https://yitaibms-web-new.oss-cn-shanghai.aliyuncs.com/%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88%E7%9C%81%E5%B8%82%E5%8E%BF%E7%AE%A1%E7%90%86%E5%91%98%EF%BC%89.pdf');
        } else {
          window.open('https://yitaieos.yujingceping.com/res/help/base/002.pdf');
        }
      }
    }
  },
  watch: {}
};